<template>
    <div id="container">
      <div id="content">
            <template v-if="total > 0">
                <h1>Listing Contact Notes ({{ pageSize * (currentPage-1) + 1 }}-{{ pageSize * (currentPage-1) + contactNotes.length }} of {{ total }})</h1>
                <el-pagination v-if="total > 200" layout="total, ->, prev, pager, next" :page-size="pageSize" :total="total" :current-page="currentPage" @current-change="handleChangePage"></el-pagination>
                <a @click="toggleShowDetails">{{ showDetails ? "hide details" : "show all details" }}</a> / <a :href="'/api/contact-note/list.xlsx?author_id=' + authorId" target="_blank">short form csv</a>
                <contact-notes-contact-notes :contactNotes="contactNotes" :showDetails="showDetails" @sortdata="val => handleSort(val)"></contact-notes-contact-notes>
                <el-pagination v-if="total > 200" layout="total, ->, prev, pager, next" :page-size="pageSize" :total="total" :current-page="currentPage" @current-change="handleChangePage"></el-pagination>
            </template>
            <template v-else-if="total === 0">
                <h1>No record matched your search terms.</h1>
            </template>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        metaInfo () {
            return {
                title: "Listing Contact Notes (" + (this.pageSize * (this.currentPage-1) + 1) + "-" + (this.pageSize * (this.currentPage-1) + this.contactNotes.length) + " of " + this.total + ")"
            }
        },
        components: {
        },
        data () {
            return {
                pageSize: 200,
                currentPage: 1,
                total: null,
                prop: "created_at",
                order: "descending",
                authorId: 0,
                showDetails: false,
                contactNotes: []
            }
        },
        methods: {
            handleChangePage: function(val) {
                this.currentPage = val;
                this.getContactNotes();
            },
            load: function() {
                this.authorId = location.pathname.split('/contact-notes/author/')[1];
                this.getContactNotes();
            },
            toggleShowDetails: function(){
                this.showDetails = !this.showDetails;
                this.getContactNotes();
            },
            getContactNotes: function() {
                axios.get('/api/contact-note/list/', {params: {author_id: this.authorId, show_details: this.showDetails, start: this.pageSize * (this.currentPage-1), limit: this.pageSize, prop: this.prop, order: this.order}})
                    .then(response => {
                        if(response.data.success) {
                            this.contactNotes = response.data.rows;
                            this.total = response.data.total;
                        }
                    })
                    .catch(error => {
                        // eslint-disable-next-line
                        console.log(error)
                    });
            },
            handleSort: function(sortObj){
                this.prop = sortObj.prop;
                this.order = sortObj.order;
                this.getContactNotes();
            }
        },
        created () {
            this.load();
        }
    }
</script>
<style scoped>
</style>
